import { LocalDate } from '../../../shared/jsr310-localdates/types/local-date.type';

export class Memo {
	id!: number;
	parcId!: number;
	ouvrageIds!: number[];
	intitule!: string;
	categorieId!: number;
	sousCategorieId!: number | null;
	niveauId!: number;
	dateDebut!: LocalDate;
	dateFin!: LocalDate | null;
	commentaire!: string;
	archived: boolean = false;

	constructor() {
	}
}